import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import { LocalStorageService, WorkflowMessagesService } from '../../../services';
import { DiscussionsView } from '../../views';
import { socket } from "../../../Context";

export class DiscussionsAction extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            showLoadingRequesting: false,
            showErrorRequesting: false,
            showCompletedRequesting: false,
            messageError: '',

            chats: [],
            selectedChat: null,
            skip: 0,

            usersChat: {},
            conversation: [],
            membersChat: [],
        };
    }

    token = {};
    user = {}
    timezone = "";

    url = process.env.REACT_APP_MIFIRMA_API;
    localStorageService = new LocalStorageService();
    workflowMessagesService = new WorkflowMessagesService(this.url);
    idAuthorMessage = 0;

    toggleLoadingScreen = (value) => {
        this.setState({
            isLoading: value
        })
    }

    toggleErrorRequesting = (value, message, time, sendInbox) => {
        this.setState({
            showErrorRequesting: value,
            messageError: message
        }, () => {
            setTimeout(() => {
                this.setState({
                    showErrorRequesting: false,
                })
                if (sendInbox) {
                    this.props.history.push("/");
                }
            }, time)
        })
    }

    toggleLoadingRequesting = (value) => {
        this.setState({
            showLoadingRequesting: value,
        });
    };

    toggleCompletedRequesting = (value) => {
        this.setState({
            showCompletedRequesting: value,
        });
    }

    getAllChats = async () => {
        let response = await this.workflowMessagesService.getChats(this.timezone, this.token);

        if (response.statusCode = 200) {
            let data = response.data;
            if (!data || Object.keys(data).length === 0) {
                this.setState({
                    chats: []
                });
                return;
            }

            data.sort((a, b) => {
                return new Date(b.lastMessage) - new Date(a.lastMessage);
            })

            this.setState({
                chats: data,
            });

            await this.showChat(data[0], data)
        } else {
            throw new Error(response?.message || "Ocurrió un error al obtener tus discusiones")
        }
    }

    showChat = async (selectedChat, data = this.state.chats) => {
        if (!selectedChat.workflowExecutionId) return;

        this.toggleLoadingRequesting(true);

        try {
            let user = {};

            //Get message and members chat
            let workflowMessage =
                await this.workflowMessagesService.getWorkFlowExecutionMessage(
                    selectedChat.workflowExecutionId,
                    this.timezone,
                    this.token
                );
            if (
                workflowMessage &&
                workflowMessage.data &&
                Number(workflowMessage.statusCode) === 200
            ) {
                //Filter out duplicated members
                let membersChat = workflowMessage.data.workflowExecutionMembers.filter((member, index) =>
                    workflowMessage.data.workflowExecutionMembers.findIndex((item) => item.email === member.email) === index
                );
                //users chat
                membersChat.map((member) => {
                    member.id = member.workflowExecutionMemberId;
                    member.avatarUrl = member.profilePicture;
                    member.name = member.firstName + " " + member.firstLastName;
                    member.avatarAltText = member.firstName + " " + member.firstLastName;
                    if (this.user.userMetaData.userA3Cloud.email === member.email) {
                        this.idAuthorMessage = member.id;
                        user = member;
                    }
                    return membersChat;
                });

                //Message chat
                workflowMessage.data.workflowExecutionMessages.map((member) => {
                    member.author = {
                        name: member.firstName + " " + member.firstLastName,
                        id: member.workflowExecutionMemberId,
                        avatarUrl: member.profilePicture,
                    };
                    member.timestamp = new Date(member.createdDate);
                    member.text = member.workflowExecutionMemberMessage;
                    member.id = member.workflowExecutionMemberId;
                    member.name = member.firstName + " " + member.firstLastName;
                    member.avatarUrl = member.profilePicture;
                    if (member.workflowExecutionMemberMessageDoc.length > 0) {
                        member.attachments = [
                            {
                                name: member.workflowExecutionMemberMessageDoc[0]?.documentName,
                                site: member.workflowExecutionMemberMessageDoc[0]?.documentPath,
                            },
                        ];
                    }
                    return workflowMessage.data.workflowExecutionMessages;
                });

                const selectedChatIndex = data.findIndex(i => i.workflowExecutionId == selectedChat.workflowExecutionId)
                const skip = Math.floor(selectedChatIndex / 6) * 6

                this.setState((prev) => {
                    if (prev.selectedChat) socket.emit("leaveRoom", prev.selectedChat.workflowExecutionId)
                    socket.emit("joinRoom", selectedChat.workflowExecutionId)

                    return {
                        selectedChat,
                        membersChat: membersChat,
                        conversation: workflowMessage.data.workflowExecutionMessages,
                        usersChat: user,
                        skip,
                    }
                })

                this.setState({
                    selectedChat,
                    membersChat: membersChat,
                    conversation: workflowMessage.data.workflowExecutionMessages,
                    usersChat: user,
                    skip,
                });
            } else {
                this.toggleErrorRequesting(true, workflowMessage.message || "Hubo un error recuperando la discusión.");
            }
        } catch (error) {
            this.toggleErrorRequesting(true, error.message);
        } finally {
            this.toggleLoadingRequesting(false);
        }
    }

    createMessage = async (messagesChat, fileContent) => {
        let data = new FormData();
        data.append("workflowExecutionId", this.state.selectedChat.workflowExecutionId);
        data.append("workflowExecutionMemberId", this.idAuthorMessage);
        data.append("message", messagesChat.text);
        data.append("documento", fileContent);
        data.append("timezone", this.timezone)

        await this.workflowMessagesService.createWorkflowExecutionNewMessage(
            data,
            this.token
        );
    }

    //add a new meessage to conversation when sockets send a mew message
    addNewMessageSocket = (message) => {
        let copyConversation = [...this.state.conversation];
        let indexMessage = copyConversation.length;
        let newMessage = {
            author: {
                name: `${message.firstName} ${message.firstLastName}`,
                id: Number(message.workflowExecutionMemberId),
                avatarUrl: message.profilePicture,
            },
            timestamp: message.workflowExcecutionMemberMessage
                ? new Date(message.workflowExcecutionMemberMessage.createdDate)
                : new Date(
                    message.workflowExecutionMemberMessageDocName[0].createdDate
                ),
            text: message.workflowExcecutionMemberMessage.message,
            id: Number(message.workflowExecutionMemberId),
            name: `${message.firstName} ${message.firstLastName}`,
            avatarUrl: message.profilePicture,
            workflowExecutionMemberId: Number(message.workflowExecutionMemberId),
            workflowExecutionMemberMessage:
                message.workflowExcecutionMemberMessage.message === "" ||
                    message.workflowExcecutionMemberMessage.message === "undefined"
                    ? null
                    : message.workflowExcecutionMemberMessage.message,
            email: message.email,
            firstName: message.firstName,
            firstLastName: message.firstLastName,
            profilePicture: message.profilePicture,
            selectionIndex: indexMessage,
        };

        if (message.workflowExecutionMemberMessageDocName.length > 0) {
            newMessage.workflowExecutionMemberMessageDoc = [
                {
                    name: message.workflowExecutionMemberMessageDocName
                        ? message.workflowExecutionMemberMessageDocName[0]
                            .workflowExecutionMemberMessageDocName
                        : "",
                    site: message.workflowExecutionMemberMessageDocName
                        ? message.workflowExecutionMemberMessageDocName[0]
                            .workflowExecutionMemberMessageDocURL
                        : "",
                },
            ];
            newMessage.attachments = [
                {
                    name: message.workflowExecutionMemberMessageDocName
                        ? message.workflowExecutionMemberMessageDocName[0]
                            .workflowExecutionMemberMessageDocName
                        : "",
                    site: message.workflowExecutionMemberMessageDocName
                        ? message.workflowExecutionMemberMessageDocName[0]
                            .workflowExecutionMemberMessageDocURL
                        : "",
                },
            ];
        }

        copyConversation.push(newMessage);
        this.setState({
            conversation: copyConversation,
        });
    };

    goToSolicitude = (dataItem) => {
        this.props.history.push(`/${dataItem.solicitudeUrl}`)
    }

    goBack = () => {
        this.props.history.goBack()
    }

    async componentDidMount() {

        this.toggleLoadingScreen(true);

        try {
            socket.on("messages", (data) => this.addNewMessageSocket(data));
            this.user = this.localStorageService.getLocalStorageItem("user");
            this.token = this.localStorageService.getLocalStorageItem("token").idToken;
            this.timezone = this.localStorageService.getLocalStorageItem("timezone");

            await this.getAllChats();

            this.toggleLoadingScreen(false);
        } catch (e) {
            this.toggleErrorRequesting(true, e.message, 4000, true)
        }
    }

    componentWillUnmount() {
        if (this.state.selectedChat) socket.emit("leaveRoom", this.state.selectedChat.workflowExecutionId)
    }

    render() {
        return (
            <DiscussionsView
                {...this.state}
                showChat={this.showChat}
                createMessage={this.createMessage}
                goToSolicitude={this.goToSolicitude}
                goBack={this.goBack}

                toggleErrorRequesting={this.toggleErrorRequesting}
                toggleLoadingRequesting={this.toggleLoadingRequesting}
                toggleCompletedRequesting={this.toggleCompletedRequesting}
            />
        )
    }
}

export default withRouter(withTranslation()(DiscussionsAction));